import { theme } from 'academy-common-lib/utils/Styling';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import { View } from 'foundations-components/transitional/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PublicSearch from '../../publicSearch/components/PublicSearch';
import PublicPageNavDropdown from './PublicPageNavDropdown';
import PublicPageNavLink from './PublicPageNavLink';
import PublicPageAuthButtons from './PublicPageAuthButtons';
import PublicPageThemeToggle from './PublicPageThemeToggle';
import PublicLanguageDropdown from '../../publicLanguage/components/PublicLanguageDropdown';
import usageTracker from '../../../utils/usageTracker';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { ListViewIcon } from 'foundations-assets/icons/components/ListViewIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PublicPageMobileNavMenu = ({
  availableLanguages,
  languageLinkedContent,
  contentType,
  pagePath
}) => {
  const {
    isShowing,
    toggle
  } = useToggle(false);
  const handleTrackNavItemClick = e => {
    usageTracker.track('navInteraction', {
      action: 'nav-item-click',
      href: e.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-controls": "mobileNavMenu",
      "aria-expanded": isShowing,
      onClick: () => toggle(),
      use: "transparent",
      children: /*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-default",
        icon: isShowing ? RemoveIcon : ListViewIcon,
        insetBlockStart: "3px",
        insetInlineStart: "-1px",
        position: "relative",
        size: "700"
      })
    }), /*#__PURE__*/_jsx(View, {
      "aria-hidden": !isShowing,
      as: "nav",
      backgroundColor: "do-not-use-olaf",
      blockSize: `calc(100vh - ${theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT})`,
      display: isShowing ? 'block' : 'none',
      id: "mobileNavMenu",
      inlineSize: "100%",
      insetBlockStart: theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT,
      insetInlineStart: "0px",
      padding: "300",
      position: "fixed",
      zIndex: 99,
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        children: /*#__PURE__*/_jsxs(List, {
          padding: "0",
          styled: false,
          children: [/*#__PURE__*/_jsx(ListItem, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(PublicSearch, {})
          }), /*#__PURE__*/_jsx(ListItem, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(PublicPageNavDropdown, {})
          }), /*#__PURE__*/_jsx(ListItem, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(PublicPageNavLink, {
              href: getProxyUrl('what-is-hubspot-academy'),
              onClick: handleTrackNavItemClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.publicNav.about"
              })
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(PublicPageAuthButtons, {})
          }), /*#__PURE__*/_jsx(ListItem, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsxs(TFlex, {
              children: [/*#__PURE__*/_jsx(PublicPageThemeToggle, {}), /*#__PURE__*/_jsx(PublicLanguageDropdown, {
                contentType: contentType,
                languageLinkedContent: languageLinkedContent,
                options: availableLanguages,
                pagePath: pagePath
              })]
            })
          })]
        })
      })
    })]
  });
};
export default PublicPageMobileNavMenu;